/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
/* eslint-disable react/no-array-index-key */
import { maxBy } from 'lodash-es';
import { Tooltip } from '@ds';
import { RefObject } from 'react';
import { useClinicalCaseContext } from '@features/contexts/ClinicalCaseContext';
import { OrganType } from '@/api/apis/case';
import { getColorsByOrganType } from '@/utils/helpers';
import { DataBar } from './DataBar';
import { ClinicalBarData } from './types';

export type ClinicalDataBarsProps = {
  listItemRefs?: RefObject<(HTMLDivElement | null)[]>;
  values: ClinicalBarData[];
  baseline?: number;
  organType: OrganType;
  verticalView: boolean;
  showLabel?: boolean;
  showValue?: boolean;
  maxVerticalBarHeight?: number;
  cardView?: boolean;
};

export const ClinicalDataBars = ({
  values,
  baseline,
  organType,
  verticalView,
  showLabel,
  showValue,
  maxVerticalBarHeight,
  listItemRefs,
  cardView,
}: ClinicalDataBarsProps) => {
  const { isScs } = useClinicalCaseContext();
  const colors = getColorsByOrganType(organType);
  const max = maxBy(values, 'value');

  return (
    <div className={`w-full pb-1 min-h-[62px] flex gap-2 ${verticalView ? 'items-end' : 'flex-col'}`}>
      {values.map((r, i) => {
        const isLast = i === values.length - 1;
        const prevItemBaseLine = isLast ? values[i - 1]?.value : 0;

        const displayTime = isScs || (organType === OrganType.Lungs && !r.isOnOcs) ? r.time : r.ocsTime;
        const tooltipContent = isScs ? r.time : `OCS ${r.ocsTime} / ${r.time}`;

        return (
          <Tooltip key={i} className={colors.bg90} content={tooltipContent} showArrow>
            <div
              role="group"
              className={cardView ? '' : 'flex-1 max-w-[25%]'}
              ref={(el) => {
                if (listItemRefs) listItemRefs.current[i] = el;
              }}
            >
              <DataBar
                cardView={cardView}
                maxVerticalBarHeight={maxVerticalBarHeight}
                verticalView={verticalView}
                color={isLast ? colors.bgSaturated : colors.bg60}
                baseline={baseline || prevItemBaseLine}
                borderColor={colors.borderSaturated}
                value={r.value}
                label={displayTime}
                max={max?.value ?? 0}
                showLabel={showLabel}
                showValue={showValue}
              />
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
};
